export const DEFAULT_TRIP_IMAGE =
  'https://images.unsplash.com/photo-1465056836041-7f43ac27dcb5?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1171&q=80'

export const MAX_TRIP_NAME_CHARS = 50

export const headerHeight = {
  sm: '56px',
  lg: '60px',
}

export const TRIP_PLANNER_PATH = '/trip-planner'
export const CHAT_TRIP_PLANNER_PATH = `${TRIP_PLANNER_PATH}/chat-trip-planner` as const
export const CHAT_TRIP_PLANNER_NEW_PATH = `${CHAT_TRIP_PLANNER_PATH}/new` as const
export const HOTEL_SEARCH_CHAT_PROMPT_QUERY_PARAM = 'hotelSearchChatPrompt'

export function getChatTripPlannerNewChatPath(query?: string): string {
  const trimmed = query?.trim()
  if (!trimmed) return CHAT_TRIP_PLANNER_NEW_PATH

  const params = new URLSearchParams({ [HOTEL_SEARCH_CHAT_PROMPT_QUERY_PARAM]: trimmed })
  return `${CHAT_TRIP_PLANNER_NEW_PATH}?${params.toString()}`
}
export const DEFAULT_FLIGHT_IMAGE_ID = 'trip-planner-default-image-13'
